// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_sxwCj","item":"index_item_UkHrq"};